/* eslint-disable max-len */
import React from 'react'

const ImageSizeTooltip = ({ handleImageToggle, imageSizeInfoHover, imgtransform, tooltipFor }) => {
    return (
        <div>
            <button
                onMouseOver={handleImageToggle}
                onMouseLeave={handleImageToggle}
                data-tooltip-target="panuploadInfo"
                data-tooltip-trigger="hover"
                data-tooltip-placement="left"
                type="button"
            >
                <img src="/images/info_tooltip.svg" alt="icon" style={{ 'transform': imgtransform, 'height':'15px' }} />
            </button>
            <div
                id="panuploadInfo"
                role="tooltip"
                class={`absolute z-10 ${imageSizeInfoHover ? '' : 'invisible'} 
                ${tooltipFor === 'Student_DOA' ? "top-[10px] w-[160px]" : tooltipFor === 'Onboard_Branch_FY' && imageSizeInfoHover ? "top-[78px] left-[-120px]" : (tooltipFor === 'Journal_ref_#'|| tooltipFor === 'GRN_INV_#') ? "top-[35px]" : "top-[-25px]"} px-1.5 py-2 bg-[#E6E8EA] rounded-[5px] w-[150px] mt-[-40px] ml-[20px]`}
            >
                {tooltipFor === 'Onboard_Branch_FY' ?
                    <><p class="text-[13px] leading-13px font-medium text-[#344054]"><span class="flex">Branch&apos;s accounting begins with this FY.</span><span class="flex mt-1">Opening balances will be posted on the FY&apos;s start date</span></p></> :
                    tooltipFor === 'Journal_ref_#' ?
                        <><p class="text-[13px] leading-13px font-medium text-[#344054]"><span class="flex">The Reference # must be unique from both the Vendor Invoice # of GRNs and the Reference # of other Journal entries.</span></p></> :
                        tooltipFor === 'GRN_INV_#' ?
                            <><p class="text-[13px] leading-13px font-medium text-[#344054]"><span class="flex">The Vendor Invoice # must be unique from both the Vendor Invoice # of other GRNs and the Reference # of Journal entries</span></p></> :
                            tooltipFor === 'Student_DOA' ?
                                <p class="text-[12px] leading-[20px] font-medium text-[#344054]">If an invoice is issued, attendance marked, or academic reports uploaded, the student’s DOA can’t be changed.
                                </p> :
                                <><p class="text-[12px] leading-13px font-medium text-[#344054]">Image Specifications:</p>
                                    <ul class="list-disc text-[12px] leading-13px pl-3">
                                        <li class="text-[12px] leading-13px font-normal text-[#344054]">Passport size image (600x600px)</li>
                                        <li class="text-[12px] leading-13px font-normal text-[#344054]">.png/.jpeg format</li>
                                        <li class="text-[12px] leading-13px font-normal text-[#344054]">Max file size 5MB</li>
                                    </ul>
                                </>
                }
            </div>
        </div>
    )
}

export default ImageSizeTooltip